import { render } from "./COIAddressEdit.vue?vue&type=template&id=1a926508"
import script from "./COIAddressEdit.vue?vue&type=script&lang=js"
export * from "./COIAddressEdit.vue?vue&type=script&lang=js"

import "./COIAddressEdit.vue?vue&type=style&index=0&id=1a926508&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__